<template>
  <div class="tipos-onu">
    <div class="form-group">
      <div class="d-flex justify-content-between">
        <div class="input-group mb-3">
          <button v-on:click="handleAdicionar()" class="btn btn-success" disabled>
            <font-awesome-icon :icon="['fas', 'plus']" fixed-width class="me-1"/>Adicionar
          </button>
        </div>

        <div class="input-group mb-3">
          <input
              v-on:keyup.enter="handlePesquisa()"
              type="text"
              class="form-control"
              placeholder="Pesquisar"
              aria-label="Pesquisar"
              aria-describedby="button-addon2">
          <button v-on:click="handlePesquisa()" class="btn btn-outline-secondary" type="button" id="button-addon2">
            <font-awesome-icon :icon="['fas', 'search']" fixed-width class="me-1"/>
          </button>
        </div>
      </div>
      <div class="d-flex">
        <table class="table table-sm-pc table-striped table-hover">
          <thead>
            <tr>
              <th width="120">Nome na OLT</th>
              <th>Descrição</th>
              <th width="80" class="text-center">Visível</th>
              <th width="120" class="text-center">Modos</th>
            </tr>
            </thead>
            <tbody>
              <tr v-for="perfil in listaPerfis" :key="perfil.id" v-on:click="handleEditaPerfilBandaOlt(perfil)" v-bind:class="cssPerfil(perfil)" class="cursor-pointer">
                <td scope="row">{{perfil.nome_olt}}</td>
                <td>{{perfil.descricao}}</td>
                <td class="text-center">
                  <font-awesome-icon v-if="perfil.visivel" :icon="['fas', 'check']" fixed-width/>
                  <font-awesome-icon v-if="!perfil.visivel" :icon="['fas', 'ban']" fixed-width/>
                  <span v-if="perfil.visivel">Sim</span>
                  <span v-if="!perfil.visivel">Não</span>
                </td>
                <td class="text-center">
                  <span v-if="perfil.modo_bridge" class="badge rounded-pill bg-secondary me-1">Bridge</span>
                  <span v-if="perfil.modo_router" class="badge rounded-pill bg-info">Router</span>
                </td>
              </tr>
            </tbody>
        </table>
      </div>
      <Paginador v-model="paginador" @change-paginacao="onChangePaginacao"/>
    </div>

    <!-- modal-edita-perfil-onu -->
    <!-- Button trigger modal -->
    <button type="button" class="d-none" data-bs-toggle="modal" data-bs-target="#modal-edita-perfil-onu" id="btn-modal-edita-perfil-onu-abre">
      Launch
    </button>

    <!-- Modal -->
    <div class="modal fade" id="modal-edita-perfil-onu" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-fullscreen-margin" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 v-if="!modalPerfilBandaOlt.data.id" class="modal-title">
              <font-awesome-icon :icon="['fas', 'plus']" fixed-width/>
              Inserir novo perfil
            </h5>
            <h5 v-if="!!modalPerfilBandaOlt.data.id" class="modal-title">
              <font-awesome-icon :icon="['fas', 'pen']" fixed-width/>
              Editando perfil
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12 col-sm-6 col-md-6 mb-2">
                <label>Nome na OLT</label>
                <input v-model="modalPerfilBandaOlt.data.nome_olt" type="text" class="form-control" disabled>
              </div>
              <div class="col-12 col-sm-6 col-md-6 mb-2">
                <label>Descrição</label>
                <input v-model="modalPerfilBandaOlt.data.descricao" type="text" class="form-control" disabled>
              </div>

              <div class="col-6 col-sm-3 col-md-3 mb-2">
                <label>Portas Ethernet</label>
                <input v-model.number="modalPerfilBandaOlt.data.portas_eth" type="number" min="0" max="16" class="form-control" disabled>
              </div>

              <div class="col-6 col-sm-3 col-md-3 mb-2">
                <label>Portas Wifi</label>
                <input v-model.number="modalPerfilBandaOlt.data.portas_wifi" type="number" min="0" max="16" class="form-control" disabled>
              </div>

              <div class="col-6 col-sm-3 col-md-3 mb-2">
                <label>Portas Telefone</label>
                <input v-model.number="modalPerfilBandaOlt.data.portas_pots" type="number" min="0" max="16" class="form-control" disabled>
              </div>

              <div class="col-6 col-sm-3 col-md-3 mb-2">
                <label>Portas RF</label>
                <input v-model.number="modalPerfilBandaOlt.data.portas_rf" type="number" min="0" max="16" class="form-control" disabled>
              </div>

              <div class="col-12 col-sm-4 col-md-4 mb-2">
                <label>Visível</label>
                <select v-model="modalPerfilBandaOlt.data.visivel" class="form-select" v-bind:disabled="modalPerfilBandaOlt.data.is_sgm_auto">
                  <option disabled :value="undefined">Selecione</option>
                  <option :value="true">Sim</option>
                  <option :value="false">Não</option>
                </select>
              </div>

              <div class="col-12 col-sm-4 col-md-4 mb-2">
                <label>Modo Bridge</label>
                <select v-model="modalPerfilBandaOlt.data.modo_bridge" class="form-select" v-bind:disabled="modalPerfilBandaOlt.data.is_sgm_auto">
                  <option disabled :value="undefined">Selecione</option>
                  <option :value="true">Sim</option>
                  <option :value="false">Não</option>
                </select>
              </div>

              <div class="col-12 col-sm-4 col-md-4 mb-2">
                <label>Modo Router</label>
                <select v-model="modalPerfilBandaOlt.data.modo_router" class="form-select" v-bind:disabled="modalPerfilBandaOlt.data.is_sgm_auto">
                  <option disabled :value="undefined">Selecione</option>
                  <option :value="true">Sim</option>
                  <option :value="false">Não</option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-between">
            <button type="button" v-on:click="handleRemovePerfilBandaOlt(modalPerfilBandaOlt.data)" class="btn btn-outline-danger" disabled>
              <font-awesome-icon :icon="['fas', 'times']" fixed-width/> Remover
            </button>

            <div>
            <button type="button" class="btn btn-outline-secondary me-1" data-bs-dismiss="modal" id="btn-modal-edita-perfil-onu-fecha">Fechar</button>
            <button type="button"
                v-if="!modalPerfilBandaOlt.data.id"
                v-on:click="handleModalPerfilBandaOltCadastrar()"
                v-bind:disabled="!podeSalvarPerfilBandaOlt()"
                class="btn btn-success">
              Cadastrar
            </button>
            <button type="button"
                v-if="!!modalPerfilBandaOlt.data.id"
                v-on:click="handleModalPerfilBandaOltSalvar()"
                v-bind:disabled="!podeSalvarPerfilBandaOlt()"
                class="btn btn-success">
              Salvar
            </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal-edita-perfil-onu -->
  </div>
</template>

<script>
import Paginador from '@/components/Paginador.vue'
import api from '@/modules/api'
import dialogo from '@/modules/dialogo'
import loading from '@/modules/loading'
import clone from '@/modules/clone'
import model from '@/model'

export default {
  name: 'ServidoresOLTTiposOnu',

  components: {
    Paginador,
  },

  data() {
    return {
      oltID: undefined,
      /** @type {model.paginador} */
      paginador: clone(model.paginador),
      listaPerfis: [],
      modalPerfilBandaOlt: {
        data: {
          id: undefined,
          nome_olt: '',
          is_sgm_auto: false,
        },
      }
    }
  },

  methods: {
    handlePesquisa() {
      loading(true);

      api.get(`/servidores/olt/${this.oltID}/tipos-onu?${this.paginador.requestParams}`).then(res => {
        loading(false);
        this.listaPerfis = res.data.itens;
        this.paginador.pagina = res.data.paginacao.pagina;
        this.paginador.totalItens = res.data.paginacao.total;
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    cssPerfil(perfil) {
      const css = [];

      if (!perfil.visivel) {
        css.push('text-muted-2');
      } else {
        css.push('text-info');
      }

      return css;
    },

    onChangePaginacao() {
      this.handlePesquisa();
    },

    resetModalPerfilBandaOlt() {
      this.modalPerfilBandaOlt.data.id = undefined;
      this.modalPerfilBandaOlt.data.descricao = '';
      this.modalPerfilBandaOlt.data.velocidade_kbps = 0;
      this.modalPerfilBandaOlt.data.tipo = undefined;
    },

    handleAdicionar() {
      this.resetModalPerfilBandaOlt();
      this.abreModalCadastroPerfilBandaOlt();
    },

    handleEditaPerfilBandaOlt(perfilISP) {
      this.resetModalPerfilBandaOlt();
      this.modalPerfilBandaOlt.data = clone(perfilISP);
      this.abreModalCadastroPerfilBandaOlt();
    },

    handleRemovePerfilBandaOlt(perfilISP) {
      dialogo.confirmacao(`Confirma remover o perfil <b>${perfilISP.descricao}</b>?`).then(() => {
        loading(true);

        api.delete(`/servidores/olt/${this.oltID}/tipos-onu/${perfilISP.id}`).then(() => {
          loading(false);

          this.handlePesquisa();
        }).catch(error => {
          loading(false);
          dialogo.erroHttp(error);
        });
      });
    },

    abreModalCadastroPerfilBandaOlt() {
      document.getElementById('btn-modal-edita-perfil-onu-abre').click();
    },

    podeSalvarPerfilBandaOlt() {
      switch (true) {
        case (this.modalPerfilBandaOlt.data.nome_olt.length < 1):
        case (this.modalPerfilBandaOlt.data.is_sgm_auto):
          return false;

        default:
          return true;
      }
    },

    handleModalPerfilBandaOltCadastrar() {
      const sendData = clone(this.modalPerfilBandaOlt.data);

      loading(true);

      api.post('/servidores/olt/${this.oltID}/tipos-onu', sendData).then(() => {
        loading(false);
        document.getElementById('btn-modal-edita-perfil-onu-fecha').click();
        this.handlePesquisa();
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    handleModalPerfilBandaOltSalvar() {
      const sendData = clone(this.modalPerfilBandaOlt.data);

      loading(true);

      api.put(`/servidores/olt/${this.oltID}/tipos-onu/${sendData.id}`, sendData).then(() => {
        loading(false);
        document.getElementById('btn-modal-edita-perfil-onu-fecha').click();
        this.handlePesquisa();
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },
  },

  created() {
    const oltID = +this.$route.params.oltID;

    if (!oltID) {
      this.$router.push({ path: `/configuracoes/servidores` });
      return;
    }

    this.oltID = oltID;

    this.handlePesquisa();
  }
}
</script>
